module.exports = [{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-netlify-identity/gatsby-browser.js'),
      options: {"plugins":[],"url":"https://jamstack-hackathon-starter.netlify.com"},
    }]
